import React from 'react';
import './css/Terms.css';

function Terms() {
  return (
    <div className="terms">
      <h2>Terms of Service</h2>

      <p>
        Welcome to VyralMining. By using our mining services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
      </p>

      <h3>1. Service Description</h3>
      <p>
        VyralMining operates a private Bitcoin mining facility, providing mining services and equipment leasing to clients. We leverage advanced hardware and infrastructure to maximize mining efficiency and profitability.
      </p>

      <h3>2. User Responsibilities</h3>
      <p>
        Users must provide valid Bitcoin wallet addresses to receive mining payouts. Users acknowledge that mining rewards depend on several factors, including pool performance, hardware uptime, and network difficulty.
      </p>

      <h3>3. No Guarantee of Profitability</h3>
      <p>
        Mining cryptocurrency involves financial risk and is subject to market volatility. VyralMining does not guarantee any specific mining outcomes or profits.
      </p>

      <h3>4. Equipment Leasing</h3>
      <p>
        VyralMining offers equipment leasing options that allow clients to use our mining hardware without managing physical devices. Leasing terms will be provided separately and must be agreed upon.
      </p>

      <h3>5. Limitation of Liability</h3>
      <p>
        VyralMining is not liable for losses, damages, or interruptions caused by hardware failure, network issues, or other technical problems.
      </p>

      <h3>6. Changes to Terms</h3>
      <p>
        We reserve the right to update these terms at any time. Continued use of the service constitutes acceptance of the updated terms.
      </p>

      <h3>7. Contact</h3>
      <p>
        For questions or concerns, please contact support at support@vyralmining.com.
      </p>
    </div>
  );
}

export default Terms;